// extracted by mini-css-extract-plugin
module.exports = {"slide":"index_slide_3auhD","slide-reverse":"index_slide-reverse_RhNMB"};